import { ListInterface } from './interfaces';

export const listInitialState: ListInterface = {
  pools: [],
  projects: [],
};
